/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const toFraction = (value: string) => {
  if (typeof value !== "string") return "";
  const fraction = Number(value) / 100;

  return fraction.toString();
};
